<template>
  <fragment>
    <v-stepper-header class="visit-header">
      <fragment
        v-for="(step, index) in getSteps"
        :key="index"
      >
        <v-stepper-step
          color="secondary"
          :step="index + 1"
          :complete="active > (index + 1)"
        >
          {{ step.label }}
        </v-stepper-step>
        <v-divider v-if="(index + 1) < getSteps.length" />
      </fragment>
    </v-stepper-header>
    <div
      v-if="active <= getSteps.length"
      class="subheading font-weight-medium"
    >
      {{ getTitle }}
    </div>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

export default {
  name: 'StepperHeader',
  components: { Fragment },
  props: {
    active: {
      type: Number,
      required: true,
    },
    steps: {
      type: Array,
      required: true,
    },
    isProfileComplete: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      displayProfileStep: !this.isProfileComplete,
    }
  },
  computed: {
    getSteps() {
      return this.displayProfileStep
        ? this.steps
        : this.steps.filter(step => step.required)
    },
    getTitle() {
      const steps = this.getSteps
      return steps[this.active - 1].label
    },
  },
}
</script>

<style scoped>
    .visit-header {
      flex: 0 1 auto;
      box-shadow: none;
    }
    @media only screen and (min-width: 960px) {
      .subheading {
        display: none;
      }
    }
</style>
